import React from "react";
import { Outlet } from "react-router-dom";
import styles from "./style.module.css";

const Layout = ({ pages }) => {
  return (
    <div className={`${styles.layout} ${styles.with_header_layout}`}>
      <div className={styles.header_layout}>
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
